<h1 mat-dialog-title>{{title}}</h1>
<mat-dialog-content>
	<p>
		{{message}}
	</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1" class="f-button">{{confirmButtonText}}</button>
	<button mat-raised-button mat-dialog-close tabindex="-1" class="f-button">{{cancelButtonText}}</button>
</mat-dialog-actions>